import * as React from 'react';
import {
	Button, ButtonType, Label
} from 'office-ui-fabric-react';
import Collapsible from 'react-collapsible';
import store from '../../store/store';
import SharedJourneyConfigContainer from '../../containers/shared-journey-config';

interface IProps {
	componentId: string;
	journeyName: string;
	previousOutputBlocks: any;
	toggleSharedJourneyConfig: (componentId: string, previousOutputBlocks: any) => void;
}
let childElement: JSX.Element;

export class SharedJourney extends React.Component<IProps, any> {
	getChildren() {
		childElement = <SharedJourneyConfigContainer />;
	}

	componentDidMount(): void {
		let { journeyName, toggleSharedJourneyConfig, componentId, previousOutputBlocks } = this.props;
		// toggleSharedJourneyConfig(componentId, previousOutputBlocks);
		this.getChildren();
	}


	render() {
		const test = store.getState().modalState.sharedJourneyConfig.SharedJourney.ComponentId;
		let { journeyName, toggleSharedJourneyConfig, componentId, previousOutputBlocks } = this.props;
		let shouldRender = store.getState().modalState.sharedJourneyConfig.SharedJourney.ComponentId ? componentId === store.getState().modalState.sharedJourneyConfig.SharedJourney.ComponentId : false;

		return (
			<div>
				{journeyName ? <Label className='selected-shared-journey'>{journeyName}</Label> : null}
				{childElement}

				{/* <Collapsible
					trigger={
						''
						// <Button buttonType={ButtonType.primary}
						// 	label='Configure Shared Journey'
						// 	title='Configure Shared Journey'
						// 	icon='Settings'
						// 	onClick={(e) => { toggleSharedJourneyConfig(componentId, previousOutputBlocks), this.getChildren() }} />

					} open={shouldRender} >
					{childElement}
				</Collapsible> */}


			</div>
		);
	}

}


// WEBPACK FOOTER //
// ./source/ts/components/components/shared-journey.tsx